import type { FC } from 'react';

import DashboardProvider from 'src/components/dashboard/DashboardContext';

import DashboardPageWrapper from './DashboardPageWrapper';

const DashboardPage: FC = () => (
  <DashboardProvider>
    <DashboardPageWrapper />
  </DashboardProvider>
);

export default DashboardPage;
